import * as React from 'react';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { formatPhone } from '../../../utils/utils';

export default class DriverCellPhone1 extends React.Component<GridCustomCellProps> {
  render() {
    if (!this.props.field) return null;
    return (
      <td {...this.props.tdProps}>
        <a href={`tel:${this.props.dataItem.DriverCellPhone1}`}>{formatPhone(this.props.dataItem.DriverCellPhone1)}</a>
      </td>
    );
  }

  public shouldComponentUpdate(nextProps: GridCustomCellProps) {
    return nextProps.dataItem.Hash !== this.props.dataItem.Hash;
  }
}
